// extracted by mini-css-extract-plugin
export default {"WinningNumber":"WinningNumber_WinningNumber__f4XwC","Balls":"WinningNumber_Balls__fFxR5"};